module.exports = __webpack_public_path__ + "img/brew2.5c55b19c.png";